export const SLIDER_CONTAINER_BREAKPOINT = '440px';
export const CLINICAL_RESULT_BADGE_TITLE = 'Clinical results';
export const CONSUMER_RESULTS_BADGE_TITLE = 'Consumer results';
